import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, ToggleButton, ButtonGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CategoryCard from '../Components/CategoryCard';
import { CategoryContext } from '../CategoryContext';
import './Categories.css';

const CategoriesPage = () => {
  const [view, setView] = useState('grid');
  const categories = useContext(CategoryContext);
  const navigate = useNavigate();

  // Load saved view from localStorage on first render
  useEffect(() => {
    const savedView = localStorage.getItem('categoryView');
    if (savedView === 'grid' || savedView === 'list') {
      setView(savedView);
    }
  }, []);

  // Save view to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('categoryView', view);
  }, [view]);

  // Get main categories (parent_id null)
  const mainCategories = categories.filter(cat => cat.parent_id === null);

  // Handle category click
  const handleCategoryClick = (categoryId) => {
    navigate(`/oglasi?categoryId=${categoryId}`);
  };

  // Handle subcategory click
  const handleSubcategoryClick = (categoryId, subcategoryId) => {
    navigate(`/oglasi?categoryId=${subcategoryId}`);
  };

  const renderGridView = () => (
    <Row className="d-flex align-items-stretch">
      {mainCategories.map((category, index) => (
        <Col key={category.id} xs={6} sm={6} md={4} lg={3} className="mb-4">
          <div className="fade-in text-decoration-none" onClick={() => handleCategoryClick(category.id)} style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'both', cursor: 'pointer' }}>
            <CategoryCard
              id={category.id}
              title={category.name}
              iconClass={category.icon}
            />
          </div>
        </Col>
      ))}
    </Row>
  );

  const renderListView = () => (
    <div className="list-view">
      {mainCategories.map(category => {
        const subcategories = categories.filter(sub => sub.parent_id === category.id);
        return (
          <div key={category.id} className="list-item d-flex align-items-center p-3 mb-4">
            <div className="icon me-3">
              <i className={category.icon} style={{ fontSize: '45px' }} />
            </div>
            <div className="content">
              <h5 className="mb-1" style={{ cursor: 'pointer' }} onClick={() => handleCategoryClick(category.id)}>
                {category.name}
              </h5>
              <div className="subcategories">
                {subcategories.map(sub => (
                  <span
                    key={sub.id}
                    className="sub-item me-2 text-decoration-none"
                    onClick={() => handleSubcategoryClick(category.id, sub.id)}
                  >
                    ● {sub.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="bg_categories">
      <div className="banner position-relative">
        <div className="overlay position-absolute"></div>
        <h1 className="banner-text position-absolute">Kategorije</h1>
      </div>
      <Container className="list_view_categories">
        <div className="d-flex justify-content-between align-items-center all_categories">
          <ButtonGroup>
            <ToggleButton
              type="radio"
              variant="outline-primary"
              className={`toggle-btn ${view === 'grid' ? 'active' : ''}`}
              checked={view === 'grid'}
              onClick={() => setView('grid')}
            >
              Kategorije
            </ToggleButton>
            <ToggleButton
              type="radio"
              variant="outline-primary"
              className={`toggle-btn ${view === 'list' ? 'active' : ''}`}
              checked={view === 'list'}
              onClick={() => setView('list')}
            >
              Podkategorije
            </ToggleButton>
          </ButtonGroup>
        </div>
        {view === 'grid' ? renderGridView() : renderListView()}
      </Container>
    </div>
  );
};

export default CategoriesPage;